module.exports = __webpack_public_path__ + "static/media/pg_tidepool_tablet_blastquiz.6d6a28ef.png";